<template>
  <b-row class="justify-content-center">
    <b-col md="6" xl="6">
      <b-card title="Detail Pengajuan Pinjaman">
        <b-overlay :show="loading" rounded="sm">
          <b-form-group label="Nama Lengkap" label-for="name">
            <b-form-input
              id="name"
              type="text"
              v-model="form.name"
              :state="state.name"
              required
            />
          </b-form-group>
          <b-form-group label="No Hp" label-for="phone">
            <b-form-input
              id="phone"
              maxlength="13"
              type="number"
              v-model="form.phone"
              :state="state.phone"
              required
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            />
          </b-form-group>
          <b-form-group label="Email" label-for="email">
            <b-form-input
              id="email"
              type="text"
              v-model="form.email"
              :state="state.email"
              required
            />
          </b-form-group>
          <b-form-group label="Jumlah Pinjaman" label-for="loan-amount">
            <cleave
              id="loan-amount"
              v-model="form.loan_amount_formatted"
              class="form-control"
              :raw="false"
              :options="options.number"
            />
          </b-form-group>
          <b-form-group label="Tenor" label-for="period">
            <b-form-select
              v-model="form.period"
              :state="state.period"
              :options="periodOptions"
            />
          </b-form-group>
          <b-form-group label="Jaminan" label-for="collateral">
            <b-form-select
              v-model="form.collateral"
              :state="state.collateral"
              :options="collateralOptions"
            />
          </b-form-group>
          <b-row class="mt-2">
            <b-col>
              <b-form-group
                label="Bukti Foto"
                label-for="image"
                class="input-image"
              >
                <div class="text-center">
                  <image-uploader
                    :preview="true"
                    :className="[
                      'fileinput',
                      'custom-file-input',
                      { 'fileinput--loaded': hasImage },
                    ]"
                    :quality="0.5"
                    :maxSize="2048"
                    :debug="0"
                    :autoRotate="true"
                    outputFormat="string"
                    @input="setImage"
                  >
                    <label for="fileInput" slot="upload-label" class="d-block">
                      <figure>
                        <feather-icon icon="CameraIcon" size="35" />
                      </figure>
                      <span class="upload-caption">{{
                        hasImage ? "Replace" : "Click to upload"
                      }}</span>
                    </label>
                  </image-uploader>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button block class="mt-2" variant="success" @click="onSend"
            >Kirim</b-button
          >
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BFormFile,
  BOverlay,
  BFormSelect,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import ImageUploader from "vue-image-upload-resize";
import Cleave from "vue-cleave-component";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BFormFile,
    flatPickr,
    ImageUploader,
    BOverlay,
    BFormSelect,
    Cleave,
  },
  data() {
    return {
      loading: false,
      hasImage: false,
      datepicker: {
        dateFormat: "d-m-Y",
      },
      state: {
        name: null,
        phone: null,
        email: null,
        image: null,
        collateral: null,
        period: null,
        loan_amount: null,
        loan_amount_formatted: null,
      },
      form: {
        name: "",
        phone: "",
        email: "",
        image: null,
        collateral: null,
        period: null,
        loan_amount: "",
        loan_amount_formatted: "",
      },
      collateralOptions: [
        { value: 1, text: "Motor" },
        { value: 2, text: "Mobil" },
      ],
      periodOptions: [
        { value: 1, text: "12 Bulan" },
        { value: 2, text: "24 Bulan" },
        { value: 3, text: "36 Bulan" },
        { value: 4, text: "48 Bulan" },
      ],
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
    };
  },
  created() {},
  methods: {
    setImage(output) {
      this.hasImage = true;
      this.form.image = output;
    },
    setImageAdd(output) {
      this.hasImageAdd = true;
      this.form.imageAdd = output;
    },
    validation() {
      if (
        this.form.name.length == 0 ||
        this.form.name == " " ||
        this.form.name == "  " ||
        this.form.name == "   "
      ) {
        this.$bvToast.toast("Nama Lengkap tidak boleh kosong", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 1000,
        });

        return false;
      }

      if (this.form.phone.length == 0) {
        this.$bvToast.toast("No Hp tidak boleh kosong", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 1000,
        });

        return false;
      }

      if (this.form.phone.length < 9) {
        this.$bvToast.toast("No Hp min harus 10 digit", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 1000,
        });

        return false;
      }

      if (this.form.email.length == 0) {
        this.$bvToast.toast("Email tidak boleh kosong", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 1000,
        });

        return false;
      }

      if (this.form.loan_amount.length == 0) {
        this.$bvToast.toast("Total pinjaman tidak boleh kosong", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 1000,
        });

        return false;
      }

      if (this.form.period == null) {
        this.$bvToast.toast("Tenor tidak boleh kosong", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 1000,
        });

        return false;
      }

      if (this.form.collateral == null) {
        this.$bvToast.toast("Jaminan tidak boleh kosong", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 1000,
        });
        return false;
      }

      if (this.form.image == null) {
        this.$bvToast.toast("Foto tidak boleh kosong", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 1000,
        });

        return false;
      }

      if (
        this.form.name.length > 0 &&
        this.form.name != " " &&
        this.form.name != "  " &&
        this.form.name != "   " &&
        this.form.phone.length > 9 &&
        this.form.email.length > 0 &&
        this.form.loan_amount.length > 0 &&
        this.form.image != null &&
        this.form.period != null &&
        this.form.collateral != null
      ) {
        return true;
      }
    },
    onSend() {
      this.form.loan_amount = this.form.loan_amount_formatted.replaceAll(",", "")
      if (this.validation()) {
        this.loading = true;
        this.$http
          .post("/adira/loan/add", this.form)
          .then((res) => {
            this.loading = false;
            this.$bvToast.toast("Berhasil", {
              title: "Berhasil",
              variant: "success",
              solid: true,
              autoHideDelay: 1000,
            });
            this.$router.push("/adira/loan");
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
            this.$bvToast.toast(err.response.data.message, {
              title: "Error",
              variant: "danger",
              solid: true,
              autoHideDelay: 1000,
            });
          });
      } else {
        this.$bvToast.toast("Oops.. Something wrong, please try again", {
              title: "Error",
              variant: "danger",
              solid: true,
              autoHideDelay: 1000,
            });
      }
    },
    makeToast(variant = null) {
      this.$bvToast.toast("Toast body content", {
        title: `Variant ${variant || "default"}`,
        variant,
        solid: true,
      });
    },
    onContext(ctx) {
      var $selected = ctx.selectedYMD;
      var $arr = $selected.split("-");
      this.form.proven_at = $arr[2] + "-" + $arr[1] + "-" + $arr[0];
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
